export enum ProviderTypes {
  MSO = 'mso', // Multiple System Operator
  LEC = 'lec', // Local Exchange Carrier
  SYNTHETIC_BUNDLE = 'bundle',
  TV = 'tv',
  WISP = 'wisp', // Wireless Internet Service Provider
}
